import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toggleGridVisibility } from './redux/gridVisibilitySlice'
import { setSelectedLayer } from './redux/selectedLayerSlice'
import { setMapPosition } from './redux/mapSlice'
import MapComponent from './pages/Map'

function App () {
  const dispatch = useDispatch()

  const isGridVisible = useSelector(
    (state) => state.gridVisibility.isGridVisible
  )
  const selectedLayer = useSelector(
    (state) => state.selectedLayer.selectedLayer
  )
  const mapPosition = useSelector((state) => state.map)

  const handleToggleGridVisibility = () => dispatch(toggleGridVisibility())
  const handleSetSelectedLayer = (layer) => dispatch(setSelectedLayer(layer))
  const handleSetMapPosition = (position) => dispatch(setMapPosition(position))

  return (
    <div className='App'>
      <MapComponent
        isGridVisible={isGridVisible}
        selectedLayer={selectedLayer}
        selectedLocation={mapPosition}
        toggleGridVisibility={handleToggleGridVisibility}
        setSelectedLayer={handleSetSelectedLayer}
        setMapPosition={handleSetMapPosition}
      />
    </div>
  )
}

export default App
